import { createContext, useContext, useState } from 'react';

const ProfileContext = createContext(null);

export function ProfileProvider({ children }) {
  const [profileCreated, setProfileCreated] = useState(true); // default true to avoid flash
  const [profileAvatar, setProfileAvatar] = useState(null); // null = not loaded yet

  return (
    <ProfileContext.Provider value={{ profileCreated, setProfileCreated, profileAvatar, setProfileAvatar }}>
      {children}
    </ProfileContext.Provider>
  );
}

export function useProfile() {
  return useContext(ProfileContext);
}
